import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NOT_AVAILABLE } from '../../common/constants/template.constant';
import { DemurrageDetentionStatusEnum } from '../../store/state/monitoring/models/shipment-common-models/demurrage-detention-status.model';

@Component({
  selector: 'ui-demurrage-detention-status',
  templateUrl: './demurrage-detention-status.component.html',
  styleUrls: ['./demurrage-detention-status.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DemurrageDetentionStatusComponent {
  @Input() status: DemurrageDetentionStatusEnum | null = null;
  @Input() size = 20;
  readonly demurrageDetentionStatus = DemurrageDetentionStatusEnum;
  readonly notAvailable: string = NOT_AVAILABLE;
}
